export const createProductionResetState = () => ({
  productionHandled: false,
  totalAnnualKwh: 0,
  totalMonthlyKwh: Array(12).fill(0),
  totalClippingKwh: 0,
  totalMonthlyClippingKwh: Array(12).fill(0),
  dcAcRatio: null,
  stringingData: null,
  invertersUsed: null,
  productionPerPanel: 0,
  productionPerPanelData: null,
  productionPerStringData: null,
  hourlyProduction: null,
  productionSaveError: null,
  selectedPanelCount: 0,
  stringingPanelIndexMode: 'all',
  stringingSelectedPanelIndexMap: null,
  stringingRoofIndexMap: null,
  systemSizeKw: null,
  mpptCountTotal: null
});

export const createProductionResetCanvas = () => ({
  total_annual_kwh: 0,
  total_monthly_kwh: Array(12).fill(0).join(','),
  total_clipping_kwh: 0,
  total_monthly_clipping_kwh: Array(12).fill(0).join(','),
  dc_ac_ratio: null,
  stringing_data: null,
  inverters_used: null,
  production_per_panel: null,
  production_per_string: null,
  hourly_production: null,
  system_size_kw: null,
  mppt_count_total: null,
  inverter_count_total: null
});
